import { createReducer, Action, on } from '@ngrx/store';

import { HomeActions } from './home.actions';
import { HomeState } from './home.state';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';

export const initialState: HomeState = {};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(
      HomeActions.LoadRecentlyAdded,
      (state): HomeState => ({ ...state, recentlyAdded: undefined, error: undefined })
    ),
    on(
      HomeActions.LoadRecentlyAddedSuccess,
      (state, action): HomeState => ({ ...state, recentlyAdded: action.list })
    ),
    on(
      HomeActions.LoadRecentlyAddedFail,
      (state, action): HomeState => ({ ...state, recentlyAdded: [], error: action.error })
    ),

    on(
      HomeActions.LoadRecentActivities,
      (state): HomeState => ({ ...state, activityRecentSummary: undefined, error: undefined })
    ),
    on(
      HomeActions.LoadRecentActivitiesSuccess,
      (state, action): HomeState => ({
        ...state,
        activityRecentSummary: action.activityRecentSummary,
      })
    ),
    on(
      HomeActions.LoadRecentActivitiesFail,
      (state, action): HomeState => ({
        ...state,
        activityRecentSummary: undefined,
        error: action.error,
      })
    ),

    on(HomeActions.LoadProductUpdates, (state): HomeState => ({ ...state, error: undefined })),
    on(
      HomeActions.LoadProductUpdatesSuccess,
      (state, action): HomeState => ({ ...state, productUpdates: action.list })
    ),
    on(
      HomeActions.LoadProductUpdatesFail,
      (state, action): HomeState => ({ ...state, productUpdates: [], error: action.error })
    )
  )
);

export function reducer(state: HomeState | undefined, action: Action) {
  return featureReducer(state, action);
}
